const getWlApiUrl = (rootState) => rootState.config.service.common['public-api-gateway'].wl_url;

export default getWlApiUrl;
